import { render, staticRenderFns } from "./ProjectChangeLog.vue?vue&type=template&id=fad34766&scoped=true"
import script from "./ProjectChangeLog.vue?vue&type=script&lang=js"
export * from "./ProjectChangeLog.vue?vue&type=script&lang=js"
import style0 from "./ProjectChangeLog.vue?vue&type=style&index=0&id=fad34766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad34766",
  null
  
)

export default component.exports